import styled, { css, keyframes } from "styled-components";
import { device } from "common/src/styles/Reset";
import theme from "styled-theming";
import gradient from "./button-gradient-01.svg";

export const shadowPulse = (color) => keyframes`
  0% {
    box-shadow: 0 0 0 0px ${color};
  }
  100% {
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
`;

export const buttonTheme = theme("dbotButton", {
  style1: css`
    border-radius: 0;
    margin-left: 15px;
    &::before {
      content: "";
      display: inline-block;
      position: absolute;
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-left-color: ${(props) => props.theme.themeGlobal.dbotAnswerColor};
      border-top: 0;
      left: 100%;
      top: 0;
    }
  `,
});

export const clientLikert = theme("client", {
  bbva: css`
    width: 30px;
    height: 30px;
  `,
});

export const Button = styled.button`
  background: #d7e4ef;
  background: ${(props) => props.theme.themeGlobal.dbotAnswerPickerButton};
  color: ${(props) => props.theme.themeGlobal.textColor};
  color: ${(props) => props.theme.themeGlobal.dbotAnswerPickerText};
  font-family: ${(props) => `${props.theme.themeGlobal.font}, 'Trebuchet MS', sans-serif`};
  border-radius: 15px 15px 0 15px;
  padding: 9px 15px;
  line-height: 115%;
  text-align: left;
  height: auto;
  position: relative;
  outline: 0;
  font-weight: normal;
  display: inline-block;
  margin: 3px 5px;
  border: 0;
  > a:link,
  > a:visited,
  > a:hover,
  > a:active {
    color: ${(props) => props.theme.themeGlobal.textColor};
    color: ${(props) => props.theme.themeGlobal.dbotAnswerPickerText};
  }
  ${buttonTheme};
  &.likert {
    background: transparent;
    color: transparent;
    border: 2px solid
      ${(props) =>
        props.sequence === props.buttonsMiddle
          ? props.theme.themeGlobal.neutral
          : props.sequence > props.buttonsMiddle
          ? props.theme.themeGlobal.positive
          : props.theme.themeGlobal.negative};
    border-radius: 50%;
    padding: 0;
    margin: 0 8px;
    width: ${(props) =>
      props.sequence === props.buttonsMiddle
        ? "15px"
        : props.sequence < props.buttonsMiddle
        ? `${(props.totalButtons - props.buttonsMiddle - props.sequence) * 10}px`
        : `${(props.sequence - props.buttonsMiddle + 1) * 10}px`};
    height: ${(props) =>
      props.sequence === props.buttonsMiddle
        ? "15px"
        : props.sequence < props.buttonsMiddle
        ? `${(props.totalButtons - props.buttonsMiddle - props.sequence) * 10}px`
        : `${(props.sequence - props.buttonsMiddle + 1) * 10}px`};
    ${clientLikert}
  }
  &.likert::before {
    display: none;
  }
  &.gradient-set {
    display: inline-block;
    margin-left: 5px;
    background-image: url(${gradient});
    background-position: ${(props) => (props.sequence >= 0 ? `${(props.sequence + 1) * 90}px 0` : 0)};
  }
  &.first-interaction {
    animation: ${(props) => shadowPulse(props.theme.themeGlobal.positive)} 1.5s infinite;
  }
  > img {
    height: 100%;
  }
  &.accelerate {
    background: ${(props) => props.theme.themeGlobal.mainDarker};
    color: #fff;
  }
  &.GAME_UNIT_CONNECTOR {
    background: ${(props) => props.theme.themeGlobal.main};
    color: #fff;
  }
  > .imageloader .gif-view {
    max-width: 150px;
    height: auto;
    border-radius: 15px 15px 0 15px;
  }

  @media ${device.laptop} {
    cursor: pointer;
    margin-right: 15px;
    margin-bottom: 5px;
  }
`;
export const InputWrapper = styled.div`
  > label input {
    padding: 8px 5px;
    max-width: 350px;
    margin: 0 auto;
  }
  > button {
    background: ${(props) => props.theme.themeGlobal.positive};
    padding: 8px;
    font-size: 1.3rem;
    color: #fff;
    border-radius: 8px 8px 8px 0;
  }
`;
